import { RecentExchangeCard } from 'app/components/recent-exchange-card';
import { RecentLoanCard } from 'app/components/recent-loan-card';
import { Text } from 'app/design/primitives/text';
import type { RecentLoanListing } from 'app/network/loan';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { InviteOthersPrompt } from '../../all-listings/components/invite-others-prompt';
import { Strategies } from '../../all-listings/components/recommended-listings';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import { landingPageLargeStyles as styles } from '../large-styles';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function RecentLoansDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { recentLoansRecommendations, shouldShowRecommendationSection, showInviteOthersPrompt } = data;
  if (!shouldShowRecommendationSection(recentLoansRecommendations, { hasEmptyState: showInviteOthersPrompt })) {
    return null;
  }
  const isHauteGaspesie = isWhiteLabel(WhiteLabel.HauteGaspesie);
  return (
    <DesktopRecommendationSection<RecentLoanListing>
      strategyProps={{ strategy: Strategies.RecentLoans }}
      recommendationState={recentLoansRecommendations}
      recommendations={recentLoansRecommendations.recommendations as RecentLoanListing[] | undefined}
      renderItem={(listing) =>
        isHauteGaspesie ? <RecentExchangeCard listing={listing} /> : <RecentLoanCard listing={listing} />
      }
      emptyState={showInviteOthersPrompt ? <InviteOthersPrompt useImage compactImage={false} /> : null}
      titleSuffix={<Text style={styles.headerIcon}>{isHauteGaspesie ? '✨' : '🤝'}</Text>}
    />
  );
}
